import queryString from 'query-string'
import { safeGet } from './http'
import { publishedGraphicsUrl } from './publishedGraphic'
import { IQuery } from '../types/search'
import { IPublishedGraphicBasic } from '../types/publishedGraphic'

export const searchPublishedGraphicsUrl = `${publishedGraphicsUrl}/search`

export const searchPublishedGraphics = (
  query: IQuery
): Promise<IPublishedGraphicBasic> => {
  // FIXME: clean up the code
  if (query.group === 'all') {
    delete query.group
  }
  return safeGet(
    `${searchPublishedGraphicsUrl}?${queryString.stringify(
      { ...query },
      { arrayFormat: 'comma' }
    )}`
  )
}
